import ChatBot from "./ChatBot";

function App() {
  return <ChatBot />;
}

export default App;
